import 'fetch-everywhere';
import uuid from 'uuid/v4';
import merge from 'deepmerge';

import hashWithoutPrototypes from './hashWithoutPrototypes';
import { getFaasApiUrl } from '../../../../selectors';

export const defaultFaasFetchOpts = {
  credentials: 'include',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  method: 'POST',
};

export const defaultCreateFetchOptionsFromCallArgs = (args) => ({ body: JSON.stringify(args) });

export const createFaasProcedureConfig = (
  functionName,
  createFetchOptsFromCallArgs = defaultCreateFetchOptionsFromCallArgs,
  hashFunction = hashWithoutPrototypes
) => {
  if (!functionName || typeof functionName !== 'string') {
    throw new Error(`functionName must be a string (was ${functionName ? typeof functionName : 'falsey'})`);
  }
  if (typeof createFetchOptsFromCallArgs !== 'function') {
    throw new TypeError(`createFetchOptsFromCallArgs must be a function (was ${typeof createFetchOptsFromCallArgs})`);
  }

  return {
    call: async ({
      fetchClient = fetch,
      getState,
      args = {},
      handleResponse = true,
    }) => {
      const correlationId = uuid();
      const fetchOpts = merge.all([
        defaultFaasFetchOpts,
        {
          headers: {
            'one-data-correlation-id': correlationId,
          },
        },
        createFetchOptsFromCallArgs(args),
      ]);

      const url = `${getFaasApiUrl(getState())}/${functionName}`;

      const res = await fetchClient(url, fetchOpts);

      if (!handleResponse) {
        return res;
      }

      const textBody = await res.text();

      if (!res.ok) {
        throw new Error(textBody);
      }

      try {
        return JSON.parse(textBody);
      } catch (e) {
        return textBody;
      }
    },

    getResultFromCache: ({ args, cache }) => {
      const hashedArgs = hashFunction(args);
      if (!cache.has(hashedArgs)) {
        throw new Error('make the call');
      }
      return cache.get(hashedArgs);
    },

    buildUpdatedCache: ({
      cache, args, result, error,
    }) => (
      typeof result === 'undefined' && typeof error === 'undefined'
        ? cache.remove(hashFunction(args))
        : cache.set(hashFunction(args), error || result)
    ),

    functionName,
  };
};
